import React, { useEffect } from 'react';
import { getBtnData, deleteData, getOneItemColleciton, logStockUsage, registerDailyStockMovement } from '../../api/Api.js';
import { db } from '../../config-firebase/firebase.js';
import PaymentMethod from '../Payment/PaymentMethod.js';
import { fetchInDataChanges } from '../../api/Api.js';
import { getFirestore, collection, doc, getDoc, runTransaction, query, where, getDocs } from 'firebase/firestore';
import { setDoc, addDoc, updateDoc } from '../../api/FirestoreInterceptor';
import style from '../../assets/styles/RequestListToBePreparedKitchen.module.scss';
import WarningAmoutMessage from '../Messages/WarningAmoutMessage';
import { Link } from 'react-router-dom';
import Title from '../title.js';
import {
  getFirstFourLetters,
  requestSorter,
  firstNameClient,
  isOrderFullyFinished,
} from '../../Helpers/Helpers.js';
import RecipeModal from './RecipeModal.js';
import KitchenTablesDashboard, { normalizeTableNumber } from './KitchenTablesDashboard';

import DefaultComumMessage from '../Messages/DefaultComumMessage.js';
import { GlobalContext } from '../../GlobalContext.js';
import { useNavigate } from 'react-router-dom';
import ButtonCustomerProfile from '../Promotions/ButtonCustomerProfile.js';
import MessagePromotions from '../Promotions/MessagePromotions.js';
import {
  isKitchenAudioMuted,
  toggleKitchenAudioMuted,
  playKitchenDishAlert,
  playStatusChangeAlert,
} from '../../Helpers/soundAlerts.js';

//import { debugErrorMap } from 'firebase/auth';

const RequestListToBePrepared = () => {
  const [requestsDoneList, setRequestDoneList] = React.useState([]);
  const [ShowDefaultMessage, setShowDefaultMessage] = React.useState(false);
  const [selectedRequestId, setSelectedRequestId] = React.useState(null);
  const [colorStatusRequest, setColorStatusRequest] = React.useState('red');
  const [isMuted, setIsMuted] = React.useState(isKitchenAudioMuted());
  const [selectedDetailDishKey, setSelectedDetailDishKey] = React.useState(null);
  const [selectedTableFilter, setSelectedTableFilter] = React.useState(null);

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setSelectedDetailDishKey(null);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleToggleSound = () => {
    const nextState = toggleKitchenAudioMuted();
    setIsMuted(nextState);
    if (!nextState) {
      playKitchenDishAlert();
    }
  };

  const isInitialSnapshotRef = React.useRef(true);
  const prevActiveDishKeysRef = React.useRef(new Set());
  const prevCancelledDishKeysRef = React.useRef(new Set());
  const prevDeliveredDishKeysRef = React.useRef(new Set());
  const [recentlyDeliveredKeys, setRecentlyDeliveredKeys] = React.useState(new Set());

  const getDishKey = (orderId, dish, index) => {
    const idx = dish.indexInRequest !== undefined ? dish.indexInRequest : index;
    return `${orderId}_idx${idx}_${dish.id || dish.name}`;
  };

  const [availableCategories, setAvailableCategories] = React.useState([]);
  const [availableDishes, setAvailableDishes] = React.useState([]);
  const [selectedCategories, setSelectedCategories] = React.useState(() => {
    try {
      const saved = localStorage.getItem('kitchenCategoryFilters');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) return parsed;
      }
      const oldSaved = localStorage.getItem('kitchenCategoryFilter');
      if (oldSaved && oldSaved !== 'all' && oldSaved !== 'todos') {
        return [oldSaved];
      }
    } catch (e) {
      console.error('Erro ao ler kitchenCategoryFilters:', e);
    }
    return [];
  });

  const selectedCategoriesRef = React.useRef(selectedCategories);
  selectedCategoriesRef.current = selectedCategories;

  const availableCategoriesRef = React.useRef(availableCategories);
  availableCategoriesRef.current = availableCategories;

  // Busca em tempo real as categorias configuradas no sistema (coleção button)
  React.useEffect(() => {
    const unsub = fetchInDataChanges('button', (data) => {
      setAvailableCategories(data || []);
    });
    return () => {
      if (unsub) unsub();
    };
  }, []);

  // Busca em tempo real os pratos e bebidas cadastrados (coleção item)
  React.useEffect(() => {
    const unsub = fetchInDataChanges('item', (data) => {
      setAvailableDishes(data || []);
    });
    return () => {
      if (unsub) unsub();
    };
  }, []);

  const doesDishMatchSingleCategory = (dish, filterCategory, categoryButtons = []) => {
    if (!filterCategory || filterCategory === 'all' || filterCategory === 'todos') {
      return true;
    }
    if (!dish) return false;

    const dishCat = (dish.category || '').toString().trim().toLowerCase();
    const filter = filterCategory.toString().trim().toLowerCase();

    if (dishCat === filter) return true;

    // Se selecionou um parent ou title de button, verifica mapeamento
    const matchingBtn = categoryButtons.find(
      (b) =>
        (b.parent && b.parent.toLowerCase() === filter) ||
        (b.title && b.title.toLowerCase() === filter) ||
        (b.id && b.id.toLowerCase() === filter)
    );

    if (matchingBtn) {
      const parent = (matchingBtn.parent || '').toLowerCase();
      const title = (matchingBtn.title || '').toLowerCase();
      if (dishCat === parent || dishCat === title) return true;
    }

    // Normalização sem acentos (ex: almoço vs almoco)
    const normDish = dishCat.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const normFilter = filter.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normDish === normFilter;
  };

  const doesDishMatchCategory = (dish, filterCategories, categoryButtons = []) => {
    if (!filterCategories || (Array.isArray(filterCategories) && filterCategories.length === 0)) {
      return true;
    }
    if (typeof filterCategories === 'string') {
      if (filterCategories === 'all' || filterCategories === 'todos') return true;
      return doesDishMatchSingleCategory(dish, filterCategories, categoryButtons);
    }
    if (Array.isArray(filterCategories)) {
      return filterCategories.some((filter) =>
        doesDishMatchSingleCategory(dish, filter, categoryButtons)
      );
    }
    return true;
  };

  const syncSoundKeysForCategories = (newCategories) => {
    const activeKeysForNewCat = new Set();
    const cancelledKeysForNewCat = new Set();
    const deliveredKeysForNewCat = new Set();

    requestsDoneList.forEach((order) => {
      if (order.request && Array.isArray(order.request)) {
        order.request.forEach((dish, idx) => {
          const key = getDishKey(order.id, dish, idx);
          if (!doesDishMatchCategory(dish, newCategories, availableCategories)) return;

          const isPending = (!dish.entregue && !dish.kitchenDelivered) || dish.refusalRequested;
          if (isPending) {
            activeKeysForNewCat.add(key);
            if (dish.cancelRequested || dish.refusalRequested) {
              cancelledKeysForNewCat.add(key);
            }
          } else if (dish.entregue && !dish.kitchenDelivered) {
            deliveredKeysForNewCat.add(key);
          }
        });
      }
    });

    prevActiveDishKeysRef.current = activeKeysForNewCat;
    prevCancelledDishKeysRef.current = cancelledKeysForNewCat;
    prevDeliveredDishKeysRef.current = deliveredKeysForNewCat;
  };

  const updateSelectedCategories = (newCategories) => {
    setSelectedCategories(newCategories);
    selectedCategoriesRef.current = newCategories;
    localStorage.setItem('kitchenCategoryFilters', JSON.stringify(newCategories));
    localStorage.setItem(
      'kitchenCategoryFilter',
      newCategories.length === 1 ? newCategories[0] : (newCategories.length === 0 ? 'all' : 'multi')
    );
    syncSoundKeysForCategories(newCategories);
  };

  const allCategoryOptions = React.useMemo(() => {
    // 1. Identificar chaves de categorias pai (aquelas que possuem subcategorias / outros botões como filhos)
    const parentCategoryKeys = new Set();
    availableCategories.forEach((b) => {
      const cat = (b.category || '').toString().trim().toLowerCase();
      if (cat && cat !== 'main' && cat !== 'hide') {
        parentCategoryKeys.add(cat);
      }
    });

    // 2. Mapear categorias que de fato têm pratos ou bebidas vinculados
    const dishCategorySet = new Set();
    availableDishes.forEach((d) => {
      const cat = (d.category || '').toString().trim().toLowerCase();
      if (cat && cat !== 'hide') {
        dishCategorySet.add(cat);
      }
    });

    requestsDoneList.forEach((order) => {
      if (order.request && Array.isArray(order.request)) {
        order.request.forEach((d) => {
          const cat = (d.category || '').toString().trim().toLowerCase();
          if (cat && cat !== 'hide') {
            dishCategorySet.add(cat);
          }
        });
      }
    });

    const optionsMap = new Map();

    // 3. Adicionar botões que NÃO são categorias pai e que possuem produtos (ou são folhas válidas)
    availableCategories.forEach((btn) => {
      if (btn.display === 'false' || btn.category === 'hide' || btn.parent === 'hide') {
        return;
      }

      const parentKey = (btn.parent || '').toString().trim().toLowerCase();
      const titleKey = (btn.title || '').toString().trim().toLowerCase();
      const idKey = (btn.id || '').toString().trim().toLowerCase();

      // Ignora se for categoria pai
      const isParent =
        parentCategoryKeys.has(parentKey) ||
        parentCategoryKeys.has(titleKey) ||
        parentCategoryKeys.has(idKey);

      if (isParent) return;

      const hasDishes =
        dishCategorySet.has(parentKey) ||
        dishCategorySet.has(titleKey) ||
        dishCategorySet.has(idKey);

      if (hasDishes || availableDishes.length === 0) {
        const key = parentKey || titleKey;
        const label = btn.title || btn.parent;
        if (key && label) {
          optionsMap.set(key, label);
        }
      }
    });

    // 4. Categorias que existem em pratos cadastrados ou pedidos ativos mas sem botão próprio
    dishCategorySet.forEach((catKey) => {
      if (!optionsMap.has(catKey) && !parentCategoryKeys.has(catKey)) {
        const label = catKey.charAt(0).toUpperCase() + catKey.slice(1);
        optionsMap.set(catKey, label);
      }
    });

    return Array.from(optionsMap.entries())
      .map(([value, label]) => ({ value, label }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [availableCategories, availableDishes, requestsDoneList]);

  const global = React.useContext(GlobalContext);
  const canSelectKitchenDishes = global?.canSelectKitchenDishes !== undefined
    ? Boolean(global.canSelectKitchenDishes)
    : (localStorage.getItem('canSelectKitchenDishes') === 'true');
  const navigate = useNavigate();
  const [recipeModal, setRecipeModal] = React.useState({
    openModal: false,
    id: '',
  });

  // const { isOpen, toggle } = useModal();
  const [promotions, setPromotions] = React.useState([]);
  const [selectedPromotion, setSelectedPromotion] = React.useState('');
  const [benefitedClient, setBenefitedClient] = React.useState([]);
  const [messagePromotionPopup, setMessagePromotionPopup] =
    React.useState(false);
  const [textPromotion, setTextPromotion] = React.useState('');
  const [AddPromotion, setAddPromotion] = React.useState(false);
  const [benefitedClientEdited, setBenefitedClientEdited] = React.useState({});
  const [operation, setOperation] = React.useState('');
  const [currentDiscount, setCurrentDiscount] = React.useState(0);
  const [currentRequest, setCurrentRequest] = React.useState(null);
  const [sideDishesList, setSideDishesList] = React.useState([]);
  const [openRequests, setOpenRequests] = React.useState({});
  const [currentTime, setCurrentTime] = React.useState(new Date());

  // Update current time every second for the stopwatch
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDuration = (ms) => {
    if (ms < 0) ms = 0;
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes} min e ${seconds} seg`;
  };

  const formatDigitalTime = (ms) => {
    if (ms < 0) ms = 0;
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');
    return `${mm}:${ss}`;
  };

  const parseDate = (str) => {
    if (!str) return new Date();
    // Remove optional ' - ' and split
    const normalized = str.replace(' - ', ' ');
    const [datePart, timePart] = normalized.split(' ');
    if (!datePart || !timePart) return new Date();
    const [day, month, year] = datePart.split('/');
    const timeParts = timePart.split(':');
    const hour = parseInt(timeParts[0], 10);
    const minute = parseInt(timeParts[1], 10);
    const second = parseInt(timeParts[2] || 0, 10);
    return new Date(Number(year), Number(month) - 1, Number(day), hour, minute, second);
  };

  React.useEffect(() => {
    const unsubscribe = fetchInDataChanges('requests', (data) => {
      // Filter: orders not delivered AND (has table OR is paid)
      let requestList = data.filter((item) =>
        item.orderDelivered === false && (item.tableNumber || item.mesa || item.paymentDone || item.deliveryAddress || item.isPdv || item.origin === 'pdv' || item.pdv)
      );
      requestList = requestSorter(requestList);

      setRequestDoneList(requestList);

      // RASTREAMENTO E ALERTA SONORO DE PRATOS NA COZINHA (FILTRADO PELA CATEGORIA DESTA TELA)
      const currentActiveKeys = new Set();
      const currentCancelledKeys = new Set();
      const currentDeliveredKeys = new Set();

      const currentFilter = selectedCategoriesRef.current;
      const currentBtns = availableCategoriesRef.current;

      requestList.forEach((order) => {
        if (order.request && Array.isArray(order.request)) {
          order.request.forEach((dish, idx) => {
            const key = getDishKey(order.id, dish, idx);
            if (!doesDishMatchCategory(dish, currentFilter, currentBtns)) return;

            const isPendingInKitchen = (!dish.entregue && !dish.kitchenDelivered) || dish.refusalRequested;
            if (isPendingInKitchen) {
              currentActiveKeys.add(key);
              if (dish.cancelRequested || dish.refusalRequested) {
                currentCancelledKeys.add(key);
              }
            } else if (dish.entregue && !dish.kitchenDelivered) {
              currentDeliveredKeys.add(key);
            }
          });
        }
      });

      if (isInitialSnapshotRef.current) {
        prevActiveDishKeysRef.current = currentActiveKeys;
        prevCancelledDishKeysRef.current = currentCancelledKeys;
        prevDeliveredDishKeysRef.current = currentDeliveredKeys;
        isInitialSnapshotRef.current = false;
      } else {
        let hasNewDishArrival = false;
        let hasNewCancellation = false;

        currentActiveKeys.forEach((key) => {
          if (!prevActiveDishKeysRef.current.has(key)) {
            hasNewDishArrival = true;
          }
        });

        currentCancelledKeys.forEach((key) => {
          if (!prevCancelledDishKeysRef.current.has(key)) {
            hasNewCancellation = true;
          }
        });

        // Detecta se algum prato acabou de ser entregue pelo garçom à mesa
        const newlyDelivered = [];
        currentDeliveredKeys.forEach((key) => {
          if (!prevDeliveredDishKeysRef.current.has(key)) {
            newlyDelivered.push(key);
          }
        });

        if (newlyDelivered.length > 0) {
          setRecentlyDeliveredKeys((prev) => {
            const next = new Set(prev);
            newlyDelivered.forEach((k) => next.add(k));
            return next;
          });

          // Agenda remoção da lista da cozinha após 3.5 segundos para mostrar o botão Entregue verde
          setTimeout(() => {
            setRecentlyDeliveredKeys((prev) => {
              const next = new Set(prev);
              newlyDelivered.forEach((k) => next.delete(k));
              return next;
            });
          }, 3500);
        }

        if (hasNewDishArrival) {
          playKitchenDishAlert();
        } else if (hasNewCancellation) {
          playStatusChangeAlert();
        }

        prevActiveDishKeysRef.current = currentActiveKeys;
        prevCancelledDishKeysRef.current = currentCancelledKeys;
        prevDeliveredDishKeysRef.current = currentDeliveredKeys;
      }
    });

    fetchData();

    return () => unsubscribe();
  }, []);

  // toda vez que a lista mudar, garante que o estado tenha as chaves corretas
  React.useEffect(() => {
    if (!requestsDoneList) return;
    setOpenRequests((prev) => {
      const next = {};
      requestsDoneList.forEach((item) => {
        // mantém valor antigo se já existia, senão começa fechado
        next[item.id] = prev[item.id] ?? false;
      });
      return next;
    });
  }, [requestsDoneList]);

  // React.useEffect(() => {
  //   if (shouldRunEffect) {
  //     if (newCustomerPromotion !== true) {
  //       if (newCustomerPromotion) {
  //         addBenefitedClientWithNoDescount(benefitedClientEdited, 'add');
  //       } else if (newCustomerPromotion === false) {
  //         addBenefitedClientWithNoDescount(benefitedClientEdited, 'edit');
  //       }
  //       setShouldRunEffect(false); // Resetar para evitar chamadas indesejadas
  //     }
  //   }
  // }, [newCustomerPromotion, shouldRunEffect]);

  const fetchUserRequests = async () => {
    let requestList = await getBtnData('requests');
    requestList = requestList.filter((item) => item.orderDelivered === false && (item.tableNumber || item.mesa || item.paymentDone || item.deliveryAddress || item.isPdv || item.origin === 'pdv' || item.pdv));
    requestList = requestSorter(requestList);
    setRequestDoneList(requestList);
  };

  const fetchData = async () => {
    try {
      const [promotionsData, benefitedClientData] = await Promise.all([
        getBtnData('Promotions'),
        getBtnData('BenefitedCustomer'),
      ]);
      const today = new Date();
      const promotionsFilter = promotionsData.filter((promotion) => {
        const startDate = new Date(promotion.startDate);
        const finalDate = new Date(promotion.finalDate);
        return today >= startDate && today < finalDate;
      });

      setPromotions(promotionsFilter);
      setBenefitedClient(benefitedClientData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const closeModal = () => {
    setShowDefaultMessage(false);
  };

  const RequestDone = async (item) => {
    try {
      await updateDoc(doc(db, 'requests', item.id), { done: false });
      setRequestDoneList((prevList) =>
        prevList.map((req) =>
          req.id === item.id ? { ...req, done: false } : req
        )
      );
      console.log('Document successfully updated !');
    } catch (error) {
      console.error(error);
    }
  };

  // const handlePaymentMethodChange = (method, item) => {
  //   item.paymentMethod = method;
  //   setDoc(doc(db, 'requests', item.id), item)
  //     .then(() => {
  //       console.log('Document successfully updated !');
  //       fetchUserRequests();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const descontFinalPrice = async (descont, idRequest) => {
    try {
      const requestRef = doc(db, 'requests', idRequest);

      const requestSnap = await getDoc(requestRef);

      if (requestSnap.exists()) {
        // Obtém o valor atual de finalPriceRequest
        const currentFinalPrice = requestSnap.data().finalPriceRequest;

        // Calcula o novo valor subtraindo o desconto
        const updatedFinalPrice = currentFinalPrice - descont;

        // Atualiza o documento no Firestore com o novo valor
        await updateDoc(requestRef, {
          finalPriceRequest: updatedFinalPrice,
        });
        console.log(
          'finalPriceRequest atualizado com sucesso para:',
          updatedFinalPrice
        );

        // Aqui você pode atualizar o estado local para refletir a mudança imediatamente na interface
        // Exemplo:
        // fetchUserRequests(); // Supondo que setFinalPriceRequest seja um estado
      } else {
        console.log('Documento não encontrado!');
      }
    } catch (error) {
      console.error('Erro ao atualizar finalPriceRequest:', error);
    }
  };

  const changeStatusPaid = async (item) => {
    item.paymentDone = true;

    // DÉBITO DE CRÉDITO DO CLIENTE (se houver idUser e o cliente tiver saldo de crédito)
    if (item.idUser) {
      try {
        const userRef = doc(db, 'user', item.idUser);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          const currentCredit = parseFloat(userData.credit || 0);
          if (currentCredit > 0) {
            const orderTotal = parseFloat(item.finalPriceRequest || 0);
            const creditUsed = Math.min(currentCredit, orderTotal);
            const creditRemaining = Math.max(0, currentCredit - creditUsed);

            item.creditUsed = Number(creditUsed.toFixed(2));
            item.creditRemaining = Number(creditRemaining.toFixed(2));
            item.previousCredit = Number(currentCredit.toFixed(2));

            await updateDoc(userRef, {
              credit: creditRemaining > 0 ? Number(creditRemaining.toFixed(2)) : 0,
            });

            console.log(
              `[CRÉDITO DEBITADO - COZINHA] Cliente: ${userData.name || 'Cliente'}, Crédito anterior: R$ ${currentCredit.toFixed(2)}, Usado: R$ ${creditUsed.toFixed(2)}, Restante: R$ ${creditRemaining.toFixed(2)}`
            );
          }
        }
      } catch (creditErr) {
        console.error('Erro ao processar débito de crédito do cliente na cozinha:', creditErr);
      }
    }

    try {
      await updateDoc(doc(db, 'requests', item.id), { paymentDone: true });
      setRequestDoneList((prevList) =>
        prevList.map((req) =>
          req.id === item.id ? { ...req, paymentDone: true } : req
        )
      );
      global.setUserNewRequest({ ...item, paymentDone: true });
      console.log('Document successfully updated !');
    } catch (error) {
      console.error(error);
    }
  };

  // const displayStatus = (item) => {
  //   if (!item?.paymentDone) return 'Não pago';
  //   if (item?.paymentDone === false && item?.done === true) return 'Não pago';
  //   if (item?.paymentDone === true && item?.done === true) {
  //     return 'Pago';
  //   }
  //   if (item?.paymentDone === true && item?.done === false) {
  //     return 'Feito';
  //   }
  //   return;
  // };
  const getStatusAndColor = (item) => {
    const fullyFinished = isOrderFullyFinished(item);

    if (!item?.paymentDone) return { status: 'Não pago', color: 'red' };
    if (item?.paymentDone === false && item?.done === true)
      return { status: 'Não pago', color: 'red' };
    
    // Se o pagamento foi feito
    if (item?.paymentDone === true) {
      // Se já foi marcado como 'done' OU se todos os itens já estão prontos/entregues
      if (item?.done === false || fullyFinished) {
        return { status: 'Feito', color: 'green' };
      }
      return { status: 'Pago', color: 'yellow' };
    }

    return { status: '', color: 'black' };
  };

  const handleToggleItemStatus = async (parentRequestId, itemIndex, field, extraFields = {}) => {
    try {
      const requestRef = doc(db, 'requests', parentRequestId);
      const requestSnap = await getDoc(requestRef);
      if (requestSnap.exists()) {
        const data = requestSnap.data();
        let newStatusValue = false;
        const updatedRequestItems = data.request.map((item) => {
          if (item.indexInRequest === itemIndex) {
            newStatusValue = !item[field];
            return { ...item, [field]: newStatusValue, ...extraFields };
          }
          return item;
        });

        await updateDoc(requestRef, { request: updatedRequestItems });
        console.log(`Item status ${field} updated for item index ${itemIndex}`);

        // Sincroniza com a coleção 'user' sempre que mudar status (pronto ou entregue)
        if (data.idUser) {
          const userRef = doc(db, 'user', data.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const updatedUserRequest = userData.request.map((userItem) => {
                // Busca o item específico usando o ID do pedido original e o índice dentro desse pedido
                const isMatch = (userItem.parentRequestId === parentRequestId || !userItem.parentRequestId) &&
                                (userItem.indexInRequest === itemIndex || (userItem.indexInRequest === undefined && userItem.id === data.request[itemIndex]?.id));
                if (isMatch) {
                  const isEntregue = field === 'entregue' ? newStatusValue : Boolean(userItem.entregue);
                  const isPronto = field === 'pronto' ? newStatusValue : Boolean(userItem.pronto);
                  const statusLabel = isEntregue ? 'Entregue' : (isPronto ? 'Pronto' : '');
                  return {
                    ...userItem,
                    [field]: newStatusValue,
                    pronto: isPronto,
                    entregue: isEntregue,
                    status: statusLabel,
                    ...extraFields
                  };
                }
                return userItem;
              });
              await updateDoc(userRef, { request: updatedUserRequest });
              console.log(`Status ${field}=${newStatusValue} sincronizado com a coleção 'user' para o pedido ${parentRequestId} item ${itemIndex}`);
            }
          }
        }
      }
    } catch (error) {
      console.error(`Error updating item status ${field}:`, error);
    }
  };

  const handleKitchenDeliverDish = async (parentRequestId, itemIndex, formattedDurationStr) => {
    try {
      const requestRef = doc(db, 'requests', parentRequestId);
      const requestSnap = await getDoc(requestRef);
      if (requestSnap.exists()) {
        const data = requestSnap.data();
        const updatedRequestItems = data.request.map((item, idx) => {
          const isTarget = item.indexInRequest === itemIndex || (item.indexInRequest === undefined && idx === itemIndex);
          if (isTarget) {
            return {
              ...item,
              kitchenDelivered: true,
              pronto: true,
              entregue: false, // Garçom e cliente continuam aguardando a entrega física na mesa
              status: 'Pronto',
              tempo_levado: item.tempo_levado || formattedDurationStr
            };
          }
          return item;
        });

        await updateDoc(requestRef, { request: updatedRequestItems });
        console.log(`Prato index ${itemIndex} despachado da cozinha (kitchenDelivered=true) no pedido ${parentRequestId}`);

        // Sincroniza com a coleção 'user' (sem marcar entregue para o cliente ainda)
        if (data.idUser) {
          const userRef = doc(db, 'user', data.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const updatedUserRequest = userData.request.map((userItem, uIdx) => {
                const isMatch = (userItem.parentRequestId === parentRequestId || !userItem.parentRequestId) &&
                                (userItem.indexInRequest === itemIndex || (userItem.indexInRequest === undefined && (userItem.id === data.request[itemIndex]?.id || uIdx === itemIndex)));
                if (isMatch) {
                  return {
                    ...userItem,
                    kitchenDelivered: true,
                    pronto: true,
                    entregue: false,
                    status: 'Pronto',
                    tempo_levado: userItem.tempo_levado || formattedDurationStr
                  };
                }
                return userItem;
              });
              await updateDoc(userRef, { request: updatedUserRequest });
            }
          }
        }
      }
    } catch (error) {
      console.error('Erro ao registrar saída de prato pela cozinha:', error);
      alert('Erro ao registrar entrega na cozinha. Tente novamente.');
    }
  };

  const handleKitchenAdjustDish = async (parentRequestId, itemIndex) => {
    try {
      const requestRef = doc(db, 'requests', parentRequestId);
      const requestSnap = await getDoc(requestRef);
      if (requestSnap.exists()) {
        const data = requestSnap.data();
        const updatedRequestItems = data.request.map((item, idx) => {
          const isTarget = item.indexInRequest === itemIndex || idx === itemIndex;
          if (isTarget) {
            return {
              ...item,
              refusalRequested: false,
              pronto: true,
              entregue: false,
              kitchenDelivered: false,
              status: 'Pronto',
              refusalResolvedAction: 'ajustado',
              stockMultiplier: 1,
              stockAction: 'adjusted',
              stockRefusalLog: 'Prato ajustado na cozinha (1 saída de matéria-prima mantida)'
            };
          }
          return item;
        });

        await updateDoc(requestRef, { request: updatedRequestItems });

        // Sincroniza com a coleção 'user'
        if (data.idUser) {
          const userRef = doc(db, 'user', data.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const updatedUserRequest = userData.request.map((userItem) => {
                const isMatch = (userItem.parentRequestId === parentRequestId || !userItem.parentRequestId) &&
                                (userItem.indexInRequest === itemIndex || (userItem.indexInRequest === undefined && userItem.id === data.request[itemIndex]?.id));
                if (isMatch) {
                  return {
                    ...userItem,
                    refusalRequested: false,
                    pronto: true,
                    entregue: false,
                    kitchenDelivered: false,
                    status: 'Pronto',
                    refusalResolvedAction: 'ajustado'
                  };
                }
                return userItem;
              });
              await updateDoc(userRef, { request: updatedUserRequest });
            }
          }
        }
      }
    } catch (error) {
      console.error('Erro ao ajustar prato na cozinha:', error);
      alert('Erro ao ajustar prato. Tente novamente.');
    }
  };

  const handleKitchenRemakeDish = async (parentRequestId, itemIndex) => {
    try {
      const requestRef = doc(db, 'requests', parentRequestId);
      const requestSnap = await getDoc(requestRef);
      if (requestSnap.exists()) {
        const data = requestSnap.data();
        const now = new Date();
        const formattedDate = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

        const updatedRequestItems = data.request.map((item, idx) => {
          const isTarget = item.indexInRequest === itemIndex || idx === itemIndex;
          if (isTarget) {
            return {
              ...item,
              refusalRequested: false,
              pronto: false,
              entregue: false,
              kitchenDelivered: false,
              status: 'Em preparo',
              sentToKitchenTime: formattedDate,
              refusalResolvedAction: 'refeito',
              stockMultiplier: 2,
              stockAction: 'remade',
              stockRefusalLog: 'Prato refeito do zero (2 saídas de matéria-prima no fechamento)'
            };
          }
          return item;
        });

        await updateDoc(requestRef, { request: updatedRequestItems });

        // Sincroniza com a coleção 'user'
        if (data.idUser) {
          const userRef = doc(db, 'user', data.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const updatedUserRequest = userData.request.map((userItem) => {
                const isMatch = (userItem.parentRequestId === parentRequestId || !userItem.parentRequestId) &&
                                (userItem.indexInRequest === itemIndex || (userItem.indexInRequest === undefined && userItem.id === data.request[itemIndex]?.id));
                if (isMatch) {
                  return {
                    ...userItem,
                    refusalRequested: false,
                    pronto: false,
                    entregue: false,
                    kitchenDelivered: false,
                    status: 'Em preparo',
                    refusalResolvedAction: 'refeito'
                  };
                }
                return userItem;
              });
              await updateDoc(userRef, { request: updatedUserRequest });
            }
          }
        }
      }
    } catch (error) {
      console.error('Erro ao refazer prato na cozinha:', error);
      alert('Erro ao refazer prato. Tente novamente.');
    }
  };

  const handleConfirmCancellation = async (parentRequestId, itemIndex, userId, isRefusal = false) => {
    try {
      const requestRef = doc(db, 'requests', parentRequestId);
      const requestSnap = await getDoc(requestRef);
      if (requestSnap.exists()) {
        const data = requestSnap.data();
        const cancelledItem = data.request.find((item, idx) => item.indexInRequest === itemIndex || idx === itemIndex) || data.request[itemIndex];
        const itemPrice = Number(cancelledItem?.finalPrice) || 0;

        // Remove do array do pedido
        const updatedRequestItems = [...data.request];
        const arrayIndexToRemove = updatedRequestItems.findIndex((item, idx) => item.indexInRequest === itemIndex || idx === itemIndex);
        if (arrayIndexToRemove !== -1) {
          updatedRequestItems.splice(arrayIndexToRemove, 1);
        }

        // Atualiza o valor total
        const newTotal = Math.max(0, (Number(data.finalPriceRequest) || 0) - itemPrice);

        // Registro no histórico de cancelamentos com log de matéria-prima
        const cancelledDishesHistory = Array.isArray(data.cancelledDishes) ? [...data.cancelledDishes] : [];
        if (cancelledItem) {
          cancelledDishesHistory.push({
            ...cancelledItem,
            cancelledAt: Date.now(),
            cancellationType: isRefusal ? 'prato_recusado' : 'cancelamento_garcom',
            stockRawMaterialLog: isRefusal ? 'Matéria prima de prato recusado (1 saída)' : 'Item cancelado antes do preparo',
            stockMultiplier: 1,
            finalPriceDeducted: itemPrice
          });
        }

        await updateDoc(requestRef, {
          request: updatedRequestItems,
          finalPriceRequest: newTotal,
          cancelledDishes: cancelledDishesHistory
        });

        // Sincroniza com o usuário
        if (userId) {
          const userRef = doc(db, 'user', userId);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            if (userData.request && Array.isArray(userData.request)) {
              const updatedUserRequest = userData.request.filter(
                (userItem) => !(userItem.parentRequestId === parentRequestId && (userItem.indexInRequest === itemIndex || userItem.name === cancelledItem?.name))
              );
              await updateDoc(userRef, { request: updatedUserRequest });
            }
          }
        }
        console.log(`Item index ${itemIndex} cancelled/refused in kitchen.`);
      }
    } catch (error) {
      console.error('Error confirming cancellation:', error);
    }
  };

  useEffect(() => {
    setColorStatusRequest('red');
  }, [requestsDoneList]);

  const updateIngredientsStock = async (item) => {
    const dateTime = item.dateTime;
    const { request } = item;
    const orderNumber = item.countRequest || '';

    if (request && request.length > 0) {
      await updateSideDihesInStock(request, dateTime, orderNumber);
    }

    for (let i = 0; i < request.length; i++) {
      const currentItem = request[i];
      const account = currentItem.name;
      const FinalingridientsList = currentItem?.recipe?.FinalingridientsList;

      console.log(`[STOCK-KITCHEN DEBUG] Processing item: ${account}, id: ${currentItem.id}, size: ${currentItem.size}`);
      console.log(`[STOCK-KITCHEN DEBUG] FinalingridientsList:`, FinalingridientsList);

      if (!FinalingridientsList) {
        console.warn(`[STOCK-KITCHEN DEBUG] No FinalingridientsList for ${account}. recipe object:`, currentItem?.recipe);
        continue;
      }

      const size = currentItem?.size;
      let listBySize = null;

      if (Array.isArray(FinalingridientsList)) {
        listBySize = FinalingridientsList;
        console.log(`[STOCK-KITCHEN DEBUG] FinalingridientsList is array. listBySize length: ${listBySize.length}`);
      } else if (typeof FinalingridientsList === 'object') {
        console.log(`[STOCK-KITCHEN DEBUG] FinalingridientsList is object.`);
        if (size) {
          if (Array.isArray(FinalingridientsList[size])) {
            listBySize = FinalingridientsList[size];
            console.log(`[STOCK-KITCHEN DEBUG] Found list for exact size: ${size}. Length: ${listBySize.length}`);
          } else {
            console.log(`[STOCK-KITCHEN DEBUG] Exact size not found. Fetching dish definition for mapping...`);
            try {
              const dishDef = await getOneItemColleciton('item', currentItem.id);
              console.log(`[STOCK-KITCHEN DEBUG] dishDef CustomizedPrice:`, dishDef?.CustomizedPrice);
              if (dishDef && dishDef.CustomizedPrice) {
                const mapping = {
                  [dishDef.CustomizedPrice.firstLabel]: 'firstPrice',
                  [dishDef.CustomizedPrice.secondLabel]: 'secondPrice',
                  [dishDef.CustomizedPrice.thirdLabel]: 'thirdPrice',
                };
                const mappedKey = mapping[size];
                console.log(`[STOCK-KITCHEN DEBUG] Mapped key for size ${size} is ${mappedKey}`);
                if (mappedKey && Array.isArray(FinalingridientsList[mappedKey])) {
                  listBySize = FinalingridientsList[mappedKey];
                  console.log(`[STOCK-KITCHEN DEBUG] Found list using mapped key ${mappedKey}. Length: ${listBySize.length}`);
                }
              }
            } catch (err) {
              console.error(`Erro ao buscar definição do prato ${currentItem.name}:`, err);
            }

            // Fallback difuso caso as labels difiram por espaços ou caixa (ex: "330 ml" vs "330ml")
            if (!listBySize) {
              console.log(`[STOCK-KITCHEN DEBUG] Fallback difuso para tamanho: ${size}`);
              const normalizedSize = size.replace(/\s+/g, '').toLowerCase();
              const foundKey = Object.keys(FinalingridientsList).find(k => 
                k.replace(/\s+/g, '').toLowerCase() === normalizedSize
              );
              console.log(`[STOCK-KITCHEN DEBUG] Fallback difuso encontrou chave: ${foundKey}`);
              if (foundKey && Array.isArray(FinalingridientsList[foundKey])) {
                listBySize = FinalingridientsList[foundKey];
                console.log(`[STOCK-KITCHEN DEBUG] Found list using fallback key ${foundKey}. Length: ${listBySize.length}`);
              }
            }
          }
        } else {
          console.log(`[STOCK-KITCHEN DEBUG] Item has no size specified, but recipe is object. Cannot determine ingredients list.`);
        }
      }

      if (Array.isArray(listBySize)) {
        console.log(`[STOCK-KITCHEN DEBUG] Proceeding to deduct ${listBySize.length} ingredients for ${account}`);
        for (let j = 0; j < listBySize.length; j++) {
          const ingredient = listBySize[j];
          const currentObj = {
            product: ingredient.name,
            totalVolume: -Number(ingredient.amount.replace(',', '.')),
            unitOfMeasurement: ingredient.unitOfMeasurement || '',
            CostPerUnit: ingredient.portionCost || 0,
            amount: 0,
            totalCost: 0,
            volumePerUnit: 0,
          };
          console.log(`[STOCK-KITCHEN DEBUG] Deducting ingredient: ${ingredient.name}, volume: ${currentObj.totalVolume}`);
          await handleStock(currentObj, account, dateTime, orderNumber);
        }
        console.log(`[STOCK-KITCHEN DEBUG] Finished deducting ingredients for ${account}`);
      } else {
        console.error(`[STOCK-KITCHEN DEBUG] CRITICAL: Não foi possível encontrar a lista de ingredientes para o tamanho "${size}" do prato "${currentItem.name}"! recipe object:`, currentItem?.recipe);
      }
    }
  };

  const updateSideDihesInStock = async (request, dateTime, orderNumber = '') => {
    if (!request || !Array.isArray(request) || request.length === 0) return;

    for (let i = 0; i < request.length; i++) {
      const currentItem = request[i];
      const account = currentItem.name;
      if (
        currentItem.sideDishes &&
        Array.isArray(currentItem.sideDishes) &&
        currentItem.sideDishes.length > 0
      ) {
        for (let j = 0; j < currentItem.sideDishes.length; j++) {
          const sideDish = currentItem.sideDishes[j];
          if (sideDish.isBasic) continue; // Pula baixa de estoque se for modo básico (sem vínculo)
          
          const portionVal = sideDish.portionUsed !== undefined ? sideDish.portionUsed : sideDish.portionCost;
          
          const currentObj = {
            product: sideDish.name,
            totalVolume: -parseToNumber(portionVal),
            unitOfMeasurement: sideDish.unit || '',
            CostPerUnit: sideDish.portionCost || 0,
            amount: 0,
            totalCost: 0,
            volumePerUnit: 0,
          };
          await handleStock(currentObj, account, dateTime, orderNumber);
        }
      }
    }
  };

  function parseToNumber(value) {
    if (typeof value === 'string') {
      return Number(value.replace(',', '.'));
    }
    return Number(value);
  }

  function round(value, decimals = 2) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
  }

  const handleStock = async (
    itemsStock,
    account = 'Editado',
    paymentDate = null,
    orderNumber = ''
  ) => {
    if (!Array.isArray(itemsStock)) {
      itemsStock = [itemsStock];
    }

    if (!paymentDate) {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mês é zero-based
      const year = today.getFullYear();
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      const seconds = String(today.getSeconds()).padStart(2, '0');
      paymentDate = `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    }

    for (let i = 0; i < itemsStock.length; i++) {
      let currentItem = itemsStock[i];

      // Busca o documento correspondente pelo nome do produto
      const stockCol = collection(db, 'stock');
      const q = query(stockCol, where('product', '==', currentItem.product));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docSnap = querySnapshot.docs[0];
        const docRef = doc(db, 'stock', docSnap.id);

        try {
          const result = await runTransaction(db, async (transaction) => {
            const freshDoc = await transaction.get(docRef);
            if (!freshDoc.exists()) {
              throw new Error('Stock item not found during transaction');
            }
            const itemFinded = freshDoc.data();
            itemFinded.id = docSnap.id; // Garante o id

            // Executa os cálculos de volume e custo usando dados frescos do servidor
            const previousCost = parseToNumber(itemFinded.totalCost);
            const previousVolume = parseToNumber(itemFinded.totalVolume);
            const cost = account === 'Editado' ? 0 : currentItem.totalCost;
            const pack =
              account === 'Editado'
                ? Number(currentItem.amount)
                : Number(itemFinded.amount) + Number(currentItem.amount);
            const volume = account === 'Editado' ? 0 : currentItem.totalVolume;
            const unit = currentItem.unitOfMeasurement;

            let updatedTotalCost = previousCost;
            let updatedTotalVolume = previousVolume;

            if (
              account !== 'Editado'
            ) {
              const volumeBefore = parseToNumber(currentItem.totalVolume);
              updatedTotalVolume = round(volumeBefore + previousVolume, 4);

              if (updatedTotalVolume <= 0) {
                if (updatedTotalVolume < 0) {
                  alert(
                    `Volume do item ${itemFinded.product || itemFinded.name} está negativo. Verifique o estoque.`
                  );
                }
                updatedTotalVolume = 0;
                updatedTotalCost = 0;
              } else if (previousVolume > 0) {
                // Redução proporcional do custo com base no volume restante
                updatedTotalCost = round(previousCost * (updatedTotalVolume / previousVolume), 2);
              } else {
                updatedTotalCost = 0;
              }
            }

            const updatedProduct = {
              ...itemFinded,
              totalCost: updatedTotalCost,
              totalVolume: updatedTotalVolume,
              amount: pack,
            };

            const logEvent = stockHistoryList(
              itemFinded,
              account,
              paymentDate,
              pack,
              cost,
              unit,
              volume,
              previousVolume,
              previousCost,
              updatedTotalCost,
              updatedTotalVolume,
              orderNumber
            );

            const cleanedProduct = cleanObject(updatedProduct);
            delete cleanedProduct.UsageHistory;
            delete cleanedProduct.id;

            transaction.update(docRef, cleanedProduct);

            return { cleanedProduct, logEvent };
          });

          await logStockUsage(docSnap.id, result.logEvent);

        } catch (txError) {
          console.error(`Erro na transação de estoque para ${currentItem.product}:`, txError);
        }

      } else {
        const logEvent = stockHistoryList(
          currentItem,
          account,
          paymentDate,
          0,
          currentItem.totalCost,
          currentItem.totalVolume,
          orderNumber
        );
        let cleanedItem = cleanObject(currentItem);
        delete cleanedItem.UsageHistory;
        
        const newDocRef = await addDoc(collection(db, 'stock'), cleanedItem);
        await logStockUsage(newDocRef.id, logEvent);
      }
    }
  };

  const cleanObject = (obj) => {
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, value]) => value !== undefined && value !== null)
          .map(([key, value]) => [key, cleanObject(value)]) // Limpa recursivamente
      );
    }
    return obj; // Retorna o valor se não for objeto
  };

  const stockHistoryList = (
    item,
    account,
    paymentDate,
    pack,
    cost,
    unit,
    volume,
    previousVolume,
    previousCost,
    totalCost,
    totalVolume,
    orderNumber = ''
  ) => {
    const stockEventRegistration = {
      date: paymentDate,
      outputProduct: Number(volume).toFixed(2),
      category: account || 0,
      unit: unit,
      package: pack,
      inputProduct: 0,
      cost: cost,
      previousVolume: previousVolume,
      previousCost: previousCost,
      ContentsInStock: totalVolume,
      totalResourceInvested: Number(totalCost).toFixed(2),
      orderNumber: orderNumber,
    };
    return stockEventRegistration;
  };

  // disparada quando o usuário seleciona uma promoção
  const handleSelectChange = async (e, item) => {
    const rawValue = e.target.value;
    if (rawValue === '') return;
    const index = Number(rawValue);
    const currentPromotion = promotions[index]; // Obtém a promoção selecionada
    const { title, reusable, rules, discount, minimumValue, promotionalItemId, promotionalItemName } = currentPromotion; // Extrai os dados da promoção
    setCurrentRequest(item);

    setSelectedPromotion(index);
    // Objeto para ser enviado pela primeira vez
    const benefitedClientObj = {
      name: item.name,
      idUser: item.idUser,
      promotionTitle: [title],
      dateTime: item.dateTime,
      currentFinalPriceRequest: item.finalPriceRequest,
      benefitUsed: [],
    };
    // benefitedClientObj.benefitUsed.push({
    //   date: item.dateTime,
    //   nomeDaPromocao: title,
    //   discount: currentPromotion.discount,
    //   listaDeProdutos: item.request.map((req) => req.name),
    // });

    // Verifica se o cliente já foi beneficiado
    const benefitedClientFinded = benefitedClient.find(
      (client) => client.idUser === item.idUser
    );
    // Se o cliente não foi beneficiado
    if (!benefitedClientFinded) {
      // setNewCustomerPromotion(true);Remove
      setMessagePromotionPopup(true); // Abre o modal
      setAddPromotion(true); // Habilita o botão de continuar
      if (minimumValue) {
        acumulativePurchase(item, benefitedClientObj, currentPromotion);
      } else {
        // Validação de disponibilidade do item promocional se houver
        if (promotionalItemId) {
          try {
            const itemPromo = await getOneItemColleciton('item', promotionalItemId);
            if (!itemPromo || itemPromo.display === false) {
              setTextPromotion(`Infelizmente o produto da promoção (${promotionalItemName}) está indisponível no momento.`);
              setAddPromotion(false);
              setMessagePromotionPopup(true);
              setSelectedPromotion('');
              return;
            }
          } catch (error) {
            console.error("Erro ao verificar item da promoção", error);
          }
        }

        const promoMsg = promotionalItemId 
          ? (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name}, acrescentando o item ${promotionalItemName} com desconto de ${discount}%. As regras são: ${rules} `
              : `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name}, acrescentando o item ${promotionalItemName} por R$ ${discount || 0}. As regras são: ${rules} `)
          : (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name} concedendo um desconto de ${discount}%. As regras são: ${rules} `
              : `Você está prestes a resgatar a promoção ${title} para o cliente ${item.name} concedendo um desconto de ${discount} reais. As regras são: ${rules} `);
        
        setTextPromotion(promoMsg);
        benefitedClientObj.benefitUsed.push({
          date: item.dateTime,
          nomeDaPromocao: title,
          discount: currentPromotion.discount,
          listaDeProdutos: item.request.map((req) => req.name),
        });
        setSelectedPromotion(''); // Limpa o select
        setBenefitedClientEdited(benefitedClientObj); //Guarda o objeto para ser enviado de forma global
        setOperation('add'); // Define a operação como adição
      }
      return;
    } else if (benefitedClientFinded) {
      // Se o cliente foi beneficiado
      if (reusable === 'false') {
        // Se a promoção não é reutilizável
        const promotionFinded = benefitedClientFinded.promotionTitle.find(
          (item) => item === title
        );
        if (promotionFinded) {
          setAddPromotion(false);
          setMessagePromotionPopup(true);

          const purchasedProducts =
            benefitedClientFinded.benefitUsed.find(
              (item) => item.nomeDaPromocao === title
            )?.listaDeProdutos || [];

          setSelectedPromotion('');
          setTextPromotion(
            `O cliente ${item.name || benefitedClientFinded.name
            } já usou a promoção ${title} na data ${item.dateTime
            } na compra dos itens ${purchasedProducts
              .map((item) => item)
              .join(', ')}`
          );
          return;
        } else {
          redeemingBenefits(benefitedClientFinded, item, currentPromotion);
          return;
        }
      }
      redeemingBenefits(benefitedClientFinded, item, currentPromotion);
      return;
    }
  };

  const redeemingBenefits = (benefitedClientFinded, item, currentPromotion) => {
    if (item.name) {
      benefitedClientFinded.name = item.name;
    }
    const clientName = item.name || benefitedClientFinded.name;

    if (currentPromotion.minimumValue) {
      acumulativePurchase(item, benefitedClientFinded, currentPromotion);
      return;
    }
    setAddPromotion(true); // Habilita o botão de continuar

    benefitedClientFinded.benefitUsed.push({
      date: item.dateTime,
      nomeDaPromocao: currentPromotion.title,
      discount: currentPromotion.discount,
      listaDeProdutos: item.request.map((req) => req.name),
    });

    const promoMsg = currentPromotion.promotionalItemId 
      ? (currentPromotion.isPercentage 
          ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
          : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
      : (currentPromotion.isPercentage 
          ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
          : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${clientName}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
    
    setTextPromotion(promoMsg);
    setCurrentDiscount(currentPromotion.discount);
    setMessagePromotionPopup(true);
    setSelectedPromotion('');
    setOperation('edit');
    setBenefitedClientEdited(benefitedClientFinded);
    if (currentPromotion.minimumValue) {
      // If the client has a minimum value to use the promotion
      benefitedClientFinded.score += Number(item.finalPriceRequest); //
      acumulativePurchase(item, benefitedClientFinded, currentPromotion);
    }
  };

  const addEditBenefitedClient = async () => {
    const selectedPromo = promotions[selectedPromotion];
    
    if (operation === 'add') {
      let finalPriceRequest = Number(currentRequest.finalPriceRequest);
      
      if (selectedPromo?.promotionalItemId) {
        // Lógica para Adicionar Item Promocional
        try {
          const itemPromo = await getOneItemColleciton('item', selectedPromo.promotionalItemId);
          if (!currentRequest.request) currentRequest.request = [];
          
          const nextIndex = currentRequest.request.length > 0 
            ? Math.max(...currentRequest.request.map(r => r.indexInRequest ?? 0)) + 1 
            : 0;

          const originalPrice = Number(itemPromo.price || 0);
          const finalItemPrice = selectedPromo.isPercentage 
            ? Math.floor(originalPrice * (1 - Number(selectedPromo.discount || 0) / 100))
            : Number(selectedPromo.discount || 0);

          const newPromoItem = {
            ...itemPromo,
            price: finalItemPrice,
            promotional: true,
            entregue: false,
            deliveredByWaiter: false,
            indexInRequest: nextIndex
          };
          
          currentRequest.request.push(newPromoItem);
          finalPriceRequest += Number(newPromoItem.price);
        } catch (error) {
          console.error("Erro ao adicionar item promocional", error);
        }
      } else {
        // Lógica de Desconto Global
        if (selectedPromo?.isPercentage) {
          finalPriceRequest = Math.floor(finalPriceRequest * (1 - Number(benefitedClientEdited.benefitUsed[0].discount || 0) / 100));
        } else {
          finalPriceRequest -= Number(benefitedClientEdited.benefitUsed[0].discount || 0);
        }
      }

      currentRequest.finalPriceRequest = finalPriceRequest < 0 ? 0 : finalPriceRequest;
      if (benefitedClientEdited.score) {
        benefitedClientEdited.score = 0.1;
      }
      if (
        Array.isArray(benefitedClientEdited.benefitUsed) &&
        benefitedClientEdited.benefitUsed.length > 0 &&
        Array.isArray(benefitedClientEdited.promotionTitle) &&
        !benefitedClientEdited.promotionTitle.includes(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao
        )
      ) {
        benefitedClientEdited.promotionTitle.push(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao
        );
      }
      // Marca que o pedido já recebeu promoção
      currentRequest.hasAppliedPromotion = true;
      currentRequest.appliedPromotion = selectedPromo?.title || 'Promoção';

      //add the promotion title to the list of promotions used by the client
      setDoc(doc(db, 'requests', currentRequest.id), currentRequest);
      const docRef = await addDoc(
        collection(db, 'BenefitedCustomer'),
        benefitedClientEdited
      );
      console.log('Document written with ID: ', docRef.id);
    } else if (operation === 'edit') {
      let finalPriceRequest = Number(currentRequest.finalPriceRequest);

      if (selectedPromo?.promotionalItemId) {
        // Lógica para Adicionar Item Promocional
        try {
          const itemPromo = await getOneItemColleciton('item', selectedPromo.promotionalItemId);
          if (!currentRequest.request) currentRequest.request = [];
          
          const nextIndex = currentRequest.request.length > 0 
            ? Math.max(...currentRequest.request.map(r => r.indexInRequest ?? 0)) + 1 
            : 0;

          const originalPrice = Number(itemPromo.price || 0);
          const finalItemPrice = selectedPromo.isPercentage 
            ? Math.floor(originalPrice * (1 - Number(selectedPromo.discount || 0) / 100))
            : Number(selectedPromo.discount || 0);

          const newPromoItem = {
            ...itemPromo,
            price: finalItemPrice,
            promotional: true,
            entregue: false,
            deliveredByWaiter: false,
            indexInRequest: nextIndex
          };
          
          currentRequest.request.push(newPromoItem);
          finalPriceRequest += Number(newPromoItem.price);
        } catch (error) {
          console.error("Erro ao adicionar item promocional", error);
        }
      } else {
        // Lógica de Desconto Global
        if (selectedPromo?.isPercentage) {
          finalPriceRequest = Math.floor(finalPriceRequest * (1 - Number(currentDiscount || 0) / 100));
        } else {
          finalPriceRequest -= Number(currentDiscount);
        }
      }

      currentRequest.finalPriceRequest = finalPriceRequest < 0 ? 0 : finalPriceRequest;

      if (benefitedClientEdited.score) {
        benefitedClientEdited.score = 0.1;
      }
      if (
        Array.isArray(benefitedClientEdited.benefitUsed) &&
        benefitedClientEdited.benefitUsed.length > 0 &&
        Array.isArray(benefitedClientEdited.promotionTitle) &&
        !benefitedClientEdited.promotionTitle.includes(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao
        )
      ) {
        benefitedClientEdited.promotionTitle.push(
          benefitedClientEdited.benefitUsed[
            benefitedClientEdited.benefitUsed.length - 1
          ]?.nomeDaPromocao
        );
      }

      // Marca que o pedido já recebeu promoção
      currentRequest.hasAppliedPromotion = true;
      currentRequest.appliedPromotion = selectedPromo?.title || 'Promoção';

      const NoEmpty = cleanObject(benefitedClientEdited);
      setBenefitedClientEdited(NoEmpty);
      setDoc(doc(db, 'requests', currentRequest.id), currentRequest);
      const docRef = doc(db, 'BenefitedCustomer', benefitedClientEdited.id);
      await updateDoc(docRef, benefitedClientEdited);
      console.log('Document updated with ID: ', benefitedClientEdited.id);
    }
  };

  const acumulativePurchase = (item, benefitedClientObj, currentPromotion) => {
    const { finalPriceRequest } = item;
    const { minimumValue } = currentPromotion;

    if (benefitedClientObj.score) {
      //if the client has a score means he already bought something
      benefitedClientObj.score += Number(item.finalPriceRequest);
      if (benefitedClientObj.score >= currentPromotion.minimumValue) {
        //benefitedClientObj.score = 0.1;
        setMessagePromotionPopup(true);
        setAddPromotion(true);
        const promoMsg = currentPromotion.promotionalItemId 
          ? (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
              : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
          : (currentPromotion.isPercentage 
              ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
              : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
        
        setTextPromotion(promoMsg);
        benefitedClientObj.benefitUsed.push({
          date: item.dateTime,
          nomeDaPromocao: currentPromotion.title,
          discount: currentPromotion.discount,
          listaDeProdutos: item.request.map((req) => req.name),
        });
        setSelectedPromotion('');
        setCurrentDiscount(currentPromotion.discount);
        setOperation('edit');
        setBenefitedClientEdited(benefitedClientObj);
        return;
      }
      setMessagePromotionPopup(true);
      //benefitedClientObj.score += Number(finalPriceRequest);
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });
      setBenefitedClientEdited(benefitedClientObj);
      setTextPromotion(
        `O cliente ${item.name
        } ainda não alcançou o valor mínimo para resgatar esse desconto. O valor atual acumulado pelo cliente referente a essa  promoção é de  ${benefitedClientObj.score
        } e o valor mínimo necessário é de ${currentPromotion.minimumValue
        } reais. Ele ainda deve consumir o valor de ${currentPromotion.minimumValue - benefitedClientObj.score
        }. As regras são:${currentPromotion.rules} `
      );
      setAddPromotion(false);
      setSelectedPromotion('');
      if (benefitedClientObj.benefitUsed.length === 1) {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'add');
      } else {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'edit');
      }
      return;
    }

    if (finalPriceRequest >= minimumValue) {
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });
      //benefitedClientObj.score = 0.1;
      setMessagePromotionPopup(true);
      setAddPromotion(true);
      const promoMsg = currentPromotion.promotionalItemId 
        ? (currentPromotion.isPercentage 
            ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} com desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
            : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, acrescentando o item ${currentPromotion.promotionalItemName} por R$ ${currentPromotion.discount || 0}. As regras são: ${currentPromotion.rules} `)
        : (currentPromotion.isPercentage 
            ? `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount}%. As regras são: ${currentPromotion.rules} `
            : `Você está prestes a resgatar a promoção ${currentPromotion.title} para o cliente ${item.name}, concedendo um desconto de ${currentPromotion.discount} reais. As regras são: ${currentPromotion.rules} `);
      
      setTextPromotion(promoMsg);
      setSelectedPromotion('');
      setOperation('add');
      setBenefitedClientEdited(benefitedClientObj);
    } else {
      benefitedClientObj.benefitUsed.push({
        date: item.dateTime,
        nomeDaPromocao: currentPromotion.title,
        discount: currentPromotion.discount,
        listaDeProdutos: item.request.map((req) => req.name),
      });

      setMessagePromotionPopup(true);
      benefitedClientObj.score = Number(finalPriceRequest);

      setBenefitedClientEdited(benefitedClientObj);
      setTextPromotion(
        `O cliente ${item.name
        } ainda não alcançou o valor mínimo para resgatar esse desconto. O valor atual acumulado pelo cliente referente a essa  promoção é de  ${item.finalPriceRequest
        } e o valor mínimo necessário é de ${currentPromotion.minimumValue
        } reais. Ele ainda deve consumir o valor de ${currentPromotion.minimumValue - finalPriceRequest
        }. As regras são:${currentPromotion.rules} `
      );
      setAddPromotion(false);
      setSelectedPromotion('');

      console.log(benefitedClientObj);
      if (benefitedClientObj.benefitUsed.length === 1) {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'add');
      } else {
        addBenefitedClientWithNoDescount(benefitedClientObj, 'edit');
      }
      // setOperation('add');

      return;
    }
  };

  const addBenefitedClientWithNoDescount = async (
    benefitedClientObj,
    action
  ) => {
    //add the client to the benefited list without discount, cause he didn't reach the minimum value
    //

    if (action === 'edit') {
      const docRef = doc(db, 'BenefitedCustomer', benefitedClientObj.id);
      await updateDoc(docRef, benefitedClientObj);
      console.log('Document updated with ID: ', benefitedClientObj.id);
      fetchData();
      fetchUserRequests();
      return;
    }
    if (action === 'add') {
      const docRef = await addDoc(
        collection(db, 'BenefitedCustomer'),
        benefitedClientObj
      );
      console.log('Document written with ID: ', docRef.id);
      fetchData();
      fetchUserRequests();
    }
  };

  const orderDelivery = async (item) => {
    try {
      if (item.name === 'anonimo' || item.name === 'anonymous') {
        if (item.idUser) {
          const userRef = doc(db, 'user', item.idUser);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            await deleteData('user', item.idUser);
          }
        }
      } else if (item.idUser) {
        const userRef = doc(db, 'user', item.idUser);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          if (userData.request && Array.isArray(userData.request)) {
            const updatedRequest = userData.request.map((reqItem) => {
              // Apenas marca como 'Pronto' os itens que pertencem a este pedido específico (item.id)
              if (reqItem.parentRequestId === item.id) {
                return { ...reqItem, status: 'Pronto' };
              }
              return reqItem;
            });
            await updateDoc(userRef, { request: updatedRequest });
          }
        } else {
          console.warn(`[WARNING] Documento de usuário ${item.idUser} não existe, pulando limpeza.`);
        }
      }
    } catch (userError) {
      console.error('Erro ao limpar carrinho do usuário (não bloqueante):', userError);
    }

    await updateIngredientsStock(item);
    await registerDailyStockMovement('Venda (Baixa Automática Cozinha)');

    item.orderDelivered = true;
    try {
      await setDoc(doc(db, 'requests', item.id), item);
      console.log('Document successfully updated !');
      fetchUserRequests();
    } catch (error) {
      console.log(error);
    }
  };

  // const openPrintScreen = (item) => {
  //   console.log('item para nota fiscal');
  //   global.setUserNewRequest(item);
  //   navigate('/print');
  // };
  const toggleRequest = (id) => {
    setOpenRequests((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className={style.containerKitchen}>
      <Link to="/admin/admin" className={style.btnBack} title="Sair do Módulo">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </Link>
      <button 
        type="button"
        onClick={handleToggleSound}
        className={style.kitchenHeaderSoundBtn}
        title={isMuted ? "Alertas sonoros desativados (clique para ativar)" : "Alertas sonoros ativados (clique para silenciar ou testar)"}
        style={{
          background: isMuted ? 'rgba(239, 83, 80, 0.15)' : 'rgba(46, 125, 50, 0.12)',
          border: isMuted ? '1px solid #ef5350' : '1px solid #66bb6a',
          color: isMuted ? '#c62828' : '#2e7d32',
        }}
      >
        {isMuted ? '🔇 Som Desativado' : '🔔 Som de Pratos Ativo'}
      </button>

      <Link to="/admin/admin" style={{ textDecoration: 'none' }}>
        <Title mainTitle="COZINHA" />
      </Link>
      <WarningAmoutMessage />

      {/* Painel de Mesas em Atendimento (largura total) */}
      <KitchenTablesDashboard
        requestsDoneList={requestsDoneList}
        selectedTableFilter={selectedTableFilter}
        onSelectTable={(table) =>
          setSelectedTableFilter((prev) => (prev === table ? null : table))
        }
        onClearFilter={() => setSelectedTableFilter(null)}
      />

      {canSelectKitchenDishes && (
        <div className={style.kitchenControlsBar}>
          <div className={style.categoryFilterSection}>
          <div className={style.categoryFilterHeader}>
            <label htmlFor="kitchenCategorySelect" className={style.filterLabel}>
              🍳 Categorias da Estação:
            </label>
            <select
              id="kitchenCategorySelect"
              className={style.categorySelect}
              value=""
              onChange={(e) => {
                const val = e.target.value;
                if (val && !selectedCategories.includes(val)) {
                  updateSelectedCategories([...selectedCategories, val]);
                }
              }}
            >
              <option value="">
                {allCategoryOptions.filter((opt) => !selectedCategories.includes(opt.value)).length > 0
                  ? '+ Adicionar Categoria à Cozinha...'
                  : 'Todas as categorias já adicionadas'}
              </option>
              {allCategoryOptions
                .filter((opt) => !selectedCategories.includes(opt.value))
                .map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
            </select>
          </div>

          <div className={style.categoryCardsContainer}>
            {selectedCategories.length === 0 ? (
              <div className={style.allCategoriesBadge}>
                <span className={style.allDot}>●</span>
                <span>Exibindo <strong>Todas as Categorias</strong> (Cozinha Geral)</span>
              </div>
            ) : (
              <div className={style.categoryCardsList}>
                {selectedCategories.map((catKey) => {
                  const opt = allCategoryOptions.find((o) => o.value === catKey);
                  const label = opt ? opt.label : (catKey.charAt(0).toUpperCase() + catKey.slice(1));
                  return (
                    <div key={catKey} className={style.categoryCard}>
                      <span className={style.cardCategoryName}>{label}</span>
                      <button
                        type="button"
                        className={style.removeCategoryBtn}
                        onClick={() => {
                          const next = selectedCategories.filter((c) => c !== catKey);
                          updateSelectedCategories(next);
                        }}
                        title={`Remover filtro ${label}`}
                        aria-label={`Remover filtro ${label}`}
                      >
                        &times;
                      </button>
                    </div>
                  );
                })}
                <button
                  type="button"
                  className={style.clearCategoriesBtn}
                  onClick={() => updateSelectedCategories([])}
                  title="Limpar todos os filtros e mostrar todas as categorias"
                >
                  Limpar Todos
                </button>
              </div>
            )}
          </div>
        </div>
        )}

        </div>
      )}
      <div className={style.kitchenItemsList}>
        {requestsDoneList &&
          (() => {
            const allItems = [];
            requestsDoneList.forEach((request) => {
              if (request.request && Array.isArray(request.request)) {
                request.request.forEach((item, indexInRequest) => {
                  const key = getDishKey(request.id, item, indexInRequest);
                  const isDelivered = item.entregue || item.kitchenDelivered;
                  if (!isDelivered || item.refusalRequested || (recentlyDeliveredKeys.has(key) && !item.kitchenDelivered)) {
                    if (doesDishMatchCategory(item, selectedCategories, availableCategories)) {
                      allItems.push({
                        ...item,
                        parentRequestId: request.id,
                        indexInRequest: item.indexInRequest !== undefined ? item.indexInRequest : indexInRequest,
                        clientName: (request.name && request.name !== 'anonimo' && request.name !== 'anonymous')
                          ? request.name
                          : (request.fantasyName || item.clientName || request.name || ''),
                        tableNumber: item.tableNumber || item.mesa || request.tableNumber || request.mesa || null,
                        deliveryAddress: item.deliveryAddress || request.deliveryAddress || null,
                        orderDate: item.sentToKitchenTime || request.dateTime,
                        dishKey: key,
                        isRecentlyDelivered: Boolean(item.entregue && !item.refusalRequested && recentlyDeliveredKeys.has(key) && !item.kitchenDelivered),
                        isPdv: Boolean(request.isPdv || item.isPdv || request.origin === 'pdv'),
                        origin: request.origin || item.origin,
                        pdv: request.pdv || item.pdv,
                      });
                    }
                  }
                });
              }
            });

            if (allItems.length === 0) {
              const filterLabels = selectedCategories
                .map((catKey) => {
                  const opt = allCategoryOptions.find((o) => o.value === catKey);
                  return opt ? opt.label : catKey;
                })
                .filter(Boolean);

              return (
                <div className={style.emptyCategoryMessage}>
                  <p>
                    {selectedCategories.length === 0
                      ? 'Nenhum pedido pendente na cozinha no momento.'
                      : `Nenhum pedido pendente para ${
                          filterLabels.length === 1
                            ? `a categoria "${filterLabels[0]}"`
                            : `as categorias: ${filterLabels.join(', ')}`
                        }.`}
                  </p>
                  <p>Aguardando novos pedidos...</p>
                </div>
              );
            }

            // Order: oldest first
            // Filtrar itens da cozinha por mesa ou pedido selecionado
            const filteredItems = allItems.filter((item) => {
              if (!selectedTableFilter) return true;
              if (selectedTableFilter.startsWith('prepago-')) {
                const prepagoId = selectedTableFilter.replace('prepago-', '');
                return item.parentRequestId === prepagoId;
              }
              const itemTable = normalizeTableNumber(item.tableNumber || item.mesa);
              return itemTable === selectedTableFilter;
            });

            // Order: oldest first
            const sortedItems = filteredItems.sort((a, b) => parseDate(a.orderDate).getTime() - parseDate(b.orderDate).getTime());
            const selectedDishItem = sortedItems.find((d) => d.dishKey === selectedDetailDishKey);

            return (
              <>
                <div className={style.kitchenItemsGrid}>
                  {sortedItems.map((item, index) => {
                    const orderDateTime = parseDate(item.orderDate);
                    const elapsedMs = currentTime - orderDateTime;
                    const formattedTime = formatDigitalTime(elapsedMs);

                    const hasAlert = item.refusalRequested || item.cancelRequested || item.isRecentlyDelivered || item.pronto;

                    const rawTable = item.tableNumber || item.mesa;
                    let tableLabel = null;
                    let tableBadgeClass = style.cardTableBadge;

                    if (rawTable !== undefined && rawTable !== null && String(rawTable).trim() !== '') {
                      const str = String(rawTable).trim();
                      tableLabel = str.toLowerCase().startsWith('mesa') ? str : `Mesa ${str}`;
                      tableBadgeClass = style.cardTableBadge;
                    } else if (item.deliveryAddress) {
                      tableLabel = 'Entrega';
                      tableBadgeClass = style.cardDeliveryBadge;
                    } else {
                      const firstName = firstNameClient(item.clientName);
                      if (firstName && firstName.toLowerCase() !== 'anonimo' && firstName.toLowerCase() !== 'anonymous') {
                        tableLabel = firstName;
                        tableBadgeClass = style.cardTableBadge;
                      } else {
                        tableLabel = 'Balcão';
                        tableBadgeClass = style.cardBalcaoBadge;
                      }
                    }

                    return (
                      <div
                        key={`${item.parentRequestId}-${item.id}-${index}`}
                        className={`${style.kitchenGridCard} ${item.pronto ? style.cardPronto : ''} ${item.cancelRequested ? style.cardCancelRequested : ''} ${item.refusalRequested ? style.cardRefusalRequested : ''} ${item.isRecentlyDelivered ? style.cardDelivered : ''}`}
                        onClick={() => setSelectedDetailDishKey(item.dishKey)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            setSelectedDetailDishKey(item.dishKey);
                          }
                        }}
                        title={`Clique para ver detalhes de ${item.name}`}
                      >
                        {hasAlert && (
                          <div className={style.cardAlertHeader}>
                            {item.refusalRequested ? (
                              <span className={style.cardBadgeRefusal}>
                                {item.refusalType === 'ajuste' ? '🛠️ Ajuste' : '🚫 Recusa'}
                              </span>
                            ) : item.cancelRequested ? (
                              <span className={style.cardBadgeCancel}>⚠️ Cancelar</span>
                            ) : item.isRecentlyDelivered ? (
                              <span className={style.cardBadgeDelivered}>✓ Entregue</span>
                            ) : item.pronto ? (
                              <span className={style.cardBadgePronto}>✓ Pronto</span>
                            ) : null}
                          </div>
                        )}

                        <div className={style.cardBody}>
                          <h4 className={style.cardTitle} title={item.name}>{item.name}</h4>
                          <div className={style.cardMeta}>
                            <span className={style.cardTime}>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="12 6 12 12 16 14"></polyline>
                              </svg>
                              {formattedTime}
                            </span>
                            {tableLabel && (
                              <span className={tableBadgeClass} title={tableLabel}>
                                {tableLabel}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {selectedDishItem && (
                  <div
                    className={style.kitchenModalOverlay}
                    onClick={(e) => {
                      if (e.target === e.currentTarget) {
                        setSelectedDetailDishKey(null);
                      }
                    }}
                  >
                    <div className={style.kitchenModalContent} role="dialog" aria-modal="true">
                      <div className={style.modalHeader}>
                        <div className={style.modalHeaderTitle}>
                          <span className={style.modalTag}>Detalhes do Pedido</span>
                        </div>
                        <button
                          type="button"
                          className={style.modalCloseBtn}
                          onClick={() => setSelectedDetailDishKey(null)}
                          aria-label="Fechar detalhes"
                          title="Fechar (Esc)"
                        >
                          &times;
                        </button>
                      </div>

                      <div
                        className={`${style.kitchenItemRow} ${style.modalItemRow} ${selectedDishItem.cancelRequested ? style.cancelRequestedRow : ''} ${selectedDishItem.isRecentlyDelivered ? style.rowDelivered : ''}`}
                        style={
                          selectedDishItem.refusalRequested
                            ? {
                                border: `3px solid ${selectedDishItem.refusalType === 'ajuste' ? '#f59e0b' : '#ef4444'}`,
                                backgroundColor: selectedDishItem.refusalType === 'ajuste' ? '#fffdf5' : '#fff5f5'
                              }
                            : selectedDishItem.cancelRequested 
                              ? { border: '3px solid red', backgroundColor: '#fff5f5' } 
                              : selectedDishItem.isRecentlyDelivered 
                                ? { border: '3px solid #28a745', backgroundColor: '#f0fff4' } 
                                : {}
                        }
                      >
                        <div className={style.itemInfo}>
                          <h4>{selectedDishItem.name}</h4>
                          {selectedDishItem.refusalRequested && (
                            <div style={{
                              backgroundColor: selectedDishItem.refusalType === 'ajuste' ? '#fef3c7' : '#fee2e2',
                              border: `2px solid ${selectedDishItem.refusalType === 'ajuste' ? '#f59e0b' : '#ef4444'}`,
                              borderRadius: '6px',
                              padding: '10px 14px',
                              marginBottom: '10px'
                            }}>
                              <p style={{
                                color: selectedDishItem.refusalType === 'ajuste' ? '#b45309' : '#b91c1c',
                                fontWeight: 'bold',
                                fontSize: '1.05rem',
                                margin: 0
                              }}>
                                {selectedDishItem.refusalType === 'ajuste' ? '🛠️ SOLICITAÇÃO DE AJUSTE' : '🚫 PRATO RECUSADO PELO CLIENTE'}
                              </p>
                              <p style={{
                                margin: '6px 0 0 0',
                                fontSize: '0.95rem',
                                color: '#1f2937'
                              }}>
                                <strong>Justificativa do Garçom:</strong> "{selectedDishItem.refusalReason}"
                              </p>
                            </div>
                          )}
                          {selectedDishItem.cancelRequested && !selectedDishItem.refusalRequested && (
                            <p style={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>⚠️ ITEM CANCELADO PELO GARÇOM</p>
                          )}
                          {selectedDishItem.isRecentlyDelivered && (
                            <p style={{ color: '#28a745', fontWeight: 'bold', fontSize: '1.1rem' }}>✓ ENTREGUE NA MESA PELO GARÇOM</p>
                          )}
                          <p><span>Cliente:</span> {firstNameClient(selectedDishItem.clientName)}</p>
                          {selectedDishItem.deliveryAddress ? (
                            <p style={{ backgroundColor: 'red', color: 'white', padding: '5px', borderRadius: '5px', fontWeight: 'bold', display: 'inline-block' }}>📍 Mesa: ENTREGA</p>
                          ) : (selectedDishItem.tableNumber || selectedDishItem.mesa) ? (
                            <p><span>Mesa:</span> {String(selectedDishItem.tableNumber || selectedDishItem.mesa).replace(/^mesa\s*/i, '')}</p>
                          ) : (
                            <p><span>Mesa:</span> {firstNameClient(selectedDishItem.clientName) || 'Balcão'}</p>
                          )}
                          <p style={{ fontWeight: 'bold', color: 'var(--title-font-color)' }}>
                            <span>Tempo:</span> {formatDuration(currentTime - parseDate(selectedDishItem.orderDate))}
                          </p>
                        </div>

                        <div className={style.itemAccompaniment}>
                          <h5>Acompanhamentos:</h5>
                          {selectedDishItem.sideDishes && selectedDishItem.sideDishes.length > 0 ? (
                            <div className={style.sideDishes}>
                              {selectedDishItem.sideDishes.map((side, sIndex) => (
                                <span key={sIndex}>{side.name}{sIndex < selectedDishItem.sideDishes.length - 1 ? ', ' : ''}</span>
                              ))}
                            </div>
                          ) : (
                            <p>Sem acompanhamentos</p>
                          )}
                          {selectedDishItem.size && <p>Tamanho: <strong>{selectedDishItem.size}</strong></p>}
                        </div>

                        <div className={style.itemActions}>
                          {selectedDishItem.refusalRequested ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                              <button
                                style={{
                                  backgroundColor: '#2563eb',
                                  color: '#ffffff',
                                  fontWeight: 'bold',
                                  padding: '8px 12px',
                                  borderRadius: '6px',
                                  border: 'none',
                                  cursor: 'pointer'
                                }}
                                onClick={() => handleKitchenAdjustDish(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest)}
                                title="O mesmo prato foi ajustado e está pronto para nova entrega ao cliente"
                              >
                                🛠️ Ajustar Prato Atual
                              </button>
                              <button
                                style={{
                                  backgroundColor: '#d97706',
                                  color: '#ffffff',
                                  fontWeight: 'bold',
                                  padding: '8px 12px',
                                  borderRadius: '6px',
                                  border: 'none',
                                  cursor: 'pointer'
                                }}
                                onClick={() => handleKitchenRemakeDish(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest)}
                                title="Prato anterior descartado. Um novo prato será feito do zero na cozinha"
                              >
                                🔄 Refazer Novo Prato
                              </button>
                              <button
                                style={{
                                  backgroundColor: '#dc2626',
                                  color: '#ffffff',
                                  fontWeight: 'bold',
                                  padding: '8px 12px',
                                  borderRadius: '6px',
                                  border: 'none',
                                  cursor: 'pointer'
                                }}
                                onClick={() => {
                                  const isConfirmed = window.confirm(`Confirmar cancelamento definitivo do item "${selectedDishItem.name}"? Ele será removido da conta do cliente.`);
                                  if (isConfirmed) {
                                    handleConfirmCancellation(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest, requestsDoneList.find(r => r.id === selectedDishItem.parentRequestId)?.idUser, true);
                                    setSelectedDetailDishKey(null);
                                  }
                                }}
                                title="Descartar o prato e cancelar da conta do cliente"
                              >
                                ❌ Cancelar Prato
                              </button>
                              <button
                                onClick={() => setRecipeModal({ openModal: true, id: selectedDishItem.id })}
                                className="btn btn-warning"
                                style={{ marginTop: '2px' }}
                              >
                                Receita
                              </button>
                            </div>
                          ) : (
                            <>
                              <button
                                disabled={selectedDishItem.pronto}
                                className={selectedDishItem.pronto ? style.done : style.pendent}
                                onClick={() => {
                                  const duration = currentTime - parseDate(selectedDishItem.orderDate);
                                  const formattedDurationStr = `tempo levado: ${formatDuration(duration)}`;
                                  handleToggleItemStatus(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest, 'pronto', { tempo_levado: formattedDurationStr });
                                }}
                              >
                                {selectedDishItem.pronto ? "Pronto ✓" : "Pronto"}
                              </button>
                              {global.allowKitchenDelivery ? (
                                <button
                                  disabled={!selectedDishItem.pronto || selectedDishItem.entregue || selectedDishItem.kitchenDelivered || selectedDishItem.cancelRequested}
                                  className={(selectedDishItem.entregue || selectedDishItem.kitchenDelivered) ? style.done : style.pendent}
                                  style={{ 
                                    opacity: (!selectedDishItem.pronto && !selectedDishItem.entregue && !selectedDishItem.kitchenDelivered) ? 0.65 : 1,
                                    cursor: (!selectedDishItem.pronto || selectedDishItem.entregue || selectedDishItem.kitchenDelivered) ? 'not-allowed' : 'pointer'
                                  }}
                                  onClick={() => {
                                    const duration = currentTime - parseDate(selectedDishItem.orderDate);
                                    const formattedDurationStr = `tempo levado: ${formatDuration(duration)}`;
                                    handleKitchenDeliverDish(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest, formattedDurationStr);
                                    setSelectedDetailDishKey(null);
                                  }}
                                  title={selectedDishItem.pronto ? "Despachar prato da cozinha (garçom continuará com a pendência de entrega à mesa)" : "O prato precisa estar Pronto antes de ser entregue"}
                                >
                                  {(selectedDishItem.entregue || selectedDishItem.kitchenDelivered) ? "Entregue ✓" : "Entregue"}
                                </button>
                              ) : (
                                <button
                                  disabled={true}
                                  className={selectedDishItem.entregue ? style.done : style.pendent}
                                  style={{ 
                                    opacity: selectedDishItem.entregue ? 1 : 0.65,
                                    cursor: 'not-allowed'
                                  }}
                                  title={selectedDishItem.entregue ? "Item entregue pelo garçom na mesa!" : "Aguardando garçom retirar e levar à mesa"}
                                >
                                  {selectedDishItem.entregue ? "Entregue ✓" : "Entregue"}
                                </button>
                              )}
                              {selectedDishItem.cancelRequested ? (
                                <button
                                  className={style.pendent}
                                  style={{ backgroundColor: 'red', color: 'white', fontWeight: 'bold' }}
                                  onClick={() => {
                                    handleConfirmCancellation(selectedDishItem.parentRequestId, selectedDishItem.indexInRequest, requestsDoneList.find(r => r.id === selectedDishItem.parentRequestId)?.idUser);
                                    setSelectedDetailDishKey(null);
                                  }}
                                >
                                  Confirmar Cancelamento
                                </button>
                              ) : (
                                <button
                                  onClick={() => setRecipeModal({ openModal: true, id: selectedDishItem.id })}
                                  className="btn btn-warning"
                                >
                                  Receita
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })()}
      </div>

      {recipeModal.openModal && (
        <RecipeModal
          setRecipeModal={setRecipeModal}
          recipeModal={recipeModal}
        />
      )}
    </div>
  );
};
export default RequestListToBePrepared;

///admin/requestlist
